import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'drawerMode'
})
export class LayoutDrawerModePipe implements PipeTransform {
    transform(isTouchScreenDevice: boolean) : 'over' | 'push' {
        if (isTouchScreenDevice) {
            return 'over';
        }
        return 'push';
    }
}
